import React from 'react';
import LinkTransition from '../common/link-transition';
import PropTypes from 'prop-types';

// Components
import HeaderNavigationTop from './navigation-top';
import NavigationMain from './navigation-main';
import NavigationLogin from './navigation-login';

import Logo from '../common/logo';

import { HeaderWrapper, Container, HeaderInner, BurgerMenu, BurgerMenuInner, BurgerMenuTrigger, LogoWrapper } from './styled.js';

const Header = ({ dark, siteTitle, currentPage, toggleMenu, currentBreakPoint, openedMenu }) => {
  return (
    (currentBreakPoint === 'desktop') ? (
      <HeaderWrapper>
        <Container>
          <HeaderNavigationTop />

          <HeaderInner>
            <LogoWrapper>
              <LinkTransition
                to="/"
                title="Go to homepage of Ludus"
                style={{
                  color: `white`,
                  textDecoration: `none`,
                }}
              >
                <span className="accessibility-hidden">Go to homepage of Ludus</span>
                <Logo
                  styleType={(dark) ? 'light' : null}
                />
              </LinkTransition>
            </LogoWrapper>
            <NavigationMain
              dark={dark}
              currentPage={currentPage}
              currentBreakPoint={currentBreakPoint}
            />
            <NavigationLogin
              dark={dark}
            />
          </HeaderInner>
        </Container>
      </HeaderWrapper>
    ) : (
      <HeaderWrapper>
        <Container>
          <HeaderInner>
            <LogoWrapper>
              <LinkTransition
                to="/"
                style={{
                  color: `white`,
                  textDecoration: `none`,
                }}
              >
                <Logo
                  styleType={(dark) ? 'light' : null}
                />
              </LinkTransition>
            </LogoWrapper>
            <BurgerMenuTrigger
              onClick={toggleMenu}
              opened={openedMenu}
            >
              <span className="accessibility-hidden">Open menu</span>
              <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H28.7179L32 4H4.10256L0 0Z"/>
                <path d="M0 10H28.7179L32 14H4.10256L0 10Z"/>
                <path d="M0 20H28.7179L32 24H4.10256L0 20Z"/>
              </svg>
            </BurgerMenuTrigger>
          </HeaderInner>
          <BurgerMenu
            className={`burger-menu${(openedMenu) ? ' opened' : ''}`}
            dark={dark}
          >
            <BurgerMenuInner>
              <NavigationMain
                dark={dark}
                currentPage={currentPage}
                showHomepage={true}
                currentBreakPoint={currentBreakPoint}
              />
              <NavigationLogin
                dark={dark}
              />
              <HeaderNavigationTop />
            </BurgerMenuInner>
              
          </BurgerMenu>
        </Container>
      </HeaderWrapper>
    ))
};

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
